import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'numToArray'
})
export class NumToArrayPipe implements PipeTransform {

	transform(value: number): number[] {
		return Array(value).fill(0).map((v: number, i: number) => i);
	}

}
